import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import {browserHistory} from 'react-router';
import {getAnimalsProtectora, loadInfoProtectoraDetail} from "../../../AnimalList/actions/actionsAnimalList";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID,
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO,
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL
} from "../../../../App/RouterAdopta";
import {checkIsLogin} from "../../actions/actionsAdmin";
import CardServicio from "./CardServicio";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../analytics/config/analyticsParamsFrontEnd";
import {sendEvent} from "../../../../analytics/analitycs"


class PanelServiciosPage extends Component {

    constructor(props) {
        super(props);


        var width = window.innerWidth;
        if (width < 992) {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 2
            }
        } else {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 3
            }
        }


        this.animalsControl = "animalsProtectora"
        this.props.isLogin();
    }

    goPerfil() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL);
    }

    goAdminAnimals() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id);
    }

    goinsertAnimal() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
    }


    render() {
        const infoProtectora = this.props.animalDetailProtectora.infoProtectoraDetail;


        return (

            <div>
                <Head
                    previousPath={""}
                />
                <div id="page-login" className="page-login main-content">
                    <div className="container" style={{width: "90%"}}>
                        <div className="page-login__wrap">
                            {/*<p className="page-login__description" style={{fontSize:"18px"}}>*/}
                            {/*    <span className="las la-lg la-address-card"  aria-hidden="true"/>Servicios*/}
                            {/*    <br/>*/}
                            {/*</p>*/}
                            <h2 className="page-login__heading">Te ayudamos a aumentar tus resultados</h2>
                            {/*<p className="page-login__description">*/}
                            {/*    <br/>*/}
                            {/*    Elige el que más se adapte a tus necesidades*/}
                            {/*</p>*/}
                        </div>
                        <br/>
                        <div className="row">

                            <CardServicio
                                titulo={"PUESTA A PUNTO"}
                                precio={"GRATIS"}
                                descripcion={"Nos encargamos de dar de alta todos tus animales en 24/48h para que no tengas que hacer el trabajo inical"}
                                img_src={process.env.CDN_URL + '/images/adoptaunanimal/servicios/mockups_ordenador-movil.png'}
                            />
                            <CardServicio
                                titulo={"AÑADIR ANIMALES POR WHATSAPP"}
                                precio={"GRATIS"}
                                descripcion={"¿Cómo? Mándanos un mensaje por WhatsApp con la información de tu peludo y nosotros lo damos de alta por ti."}
                                img_src={process.env.CDN_URL + '/images/adoptaunanimal/servicios/servicio_add_animal_by_WA_copia.png'}
                            />
                            {/*<CardServicio*/}
                            {/*    titulo={"QUEREMOS CONTAR TU HISTORIA"}*/}
                            {/*    precio={"GRATIS"}*/}
                            {/*    descripcion={"Montamos un videoreportaje de protectoras y asocicaciones, ¡queremos montar tu historia! y ayudarte a lograr más difusión"}*/}
                            {/*    img_src={process.env.CDN_URL + '/images/adoptaunanimal/servicios/mockups_ordenador-movil.png'}*/}
                            {/*/>*/}
                        </div>

                    </div>
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
            </div>
        );
    }

    componentWillMount() {
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        } else {
            this.props.loadInfoProtectoraDetail(this.props.access.id, this.animalsControl, "completa");
            this.props.getAnimalsProtectora({varsData: {id_protectora: this.props.access.id}});
        }

        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({
                scrollTop: element.offset().top
            }, 0);
        }

    }

    componentDidMount() {

        // $('.page-login').addClass('animated-400ms fadeIn');
        $('.page-login').show();
        // let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (this.props.animals === undefined || this.props.animals.length === 0) {
            this.props.getAnimalsProtectora({varsData: {id_protectora: this.props.access.id}});
        }

        if (!this.props.showHead) {

            // $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }

        sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.ADMIN.PANEL_SERVICIOS, {
            id_protectora: this.props.access.id,
            email_protectora: this.props.access.user
        });
    }

}

function mapStateToProps(state) {
    return {
        access: state.access,
        showHead: state.structureControl.showHead,
        animalDetailProtectora: state.animalDetailProtectora,
        animals: state.animalsProtectora.list
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    isLogin: checkIsLogin,
    loadInfoProtectoraDetail,
    getAnimalsProtectora
})(PanelServiciosPage)
